import { createAction, props } from '@ngrx/store';

import { ParentReportExecutionDataModel } from '@ag-grid-reports/ag-grid-base/models/parent-row-data.model';
import { StatKey } from '@containers/reports/dashboard/multi-chart/models/statKey.model';
import { ISite } from '@shared/types';
import { IPublishedReport, IReport, ReportOptions } from '@shared/types/report';
import { IDatepickerValue } from '@xenial-ux/xux-datepicker/types';

export const GET_REPORTS = 'GET_REPORTS';
export const GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS';
export const GET_REPORTS_FAILURE = 'GET_REPORTS_FAILURE';

export const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS';
export const GET_STATS_FAILURE = 'GET_STATS_FAILURE';

export const ADD_DASHBOARD_DATES = 'ADD_DASHBOARD_DATES';
export const ADD_DASHBOARD_DAYPARTS = 'ADD_DASHBOARD_DAYPARTS';
export const ADD_DASHBOARD_DESTINATIONS = 'ADD_DASHBOARD_DESTINATIONS';
export const ADD_DASHBOARD_HOURS = 'ADD_DASHBOARD_HOURS';
export const ADD_DASHBOARD_HEADER = 'ADD_DASHBOARD_HEADER';
export const SET_DASHBOARD_LAST_RUN_FILTER = 'SET_DASHBOARD_LAST_RUN_FILTER';

export const SELECT_REPORT = 'SELECT_REPORT';
export const SELECT_REPORT_SUCCESS = 'SELECT_REPORT_SUCCESS';
export const SELECT_REPORT_FAILURE = 'SELECT_REPORT_FAILURE';
export const REMOVE_REPORT = 'REMOVE_REPORT';

export const SET_REPORT_FILTER = 'SET_REPORT_FILTER';
export const SET_REPORT_FILTER_SUCCESS = 'SET_REPORT_FILTER_SUCCESS';
export const SET_REPORT_FILTER_FAILURE = 'SET_REPORT_FILTER_FAILURE';

export const SET_REPORT_ETL_STATISTICS = 'SET_REPORT_ETL_STATISTICS';
export const RESET_REPORT_ETL_STATISTICS = 'RESET_REPORT_ETL_STATISTICS';
export const SET_REPORT_ETL_STATISTICS_FAILURE = 'SET_REPORT_ETL_STATISTICS_FAILURE';
export const SET_REPORT_ETL_STATISTICS_SUCCESS = 'SET_REPORT_ETL_STATISTICS_SUCCESS';

export const SET_REPORT_URL = 'SET_REPORT_URL';
export const SET_REPORT_URL_FAILURE = 'SET_REPORT_URL_FAILURE';
export const SET_REPORT_URL_SUCCESS = 'SET_REPORT_URL_SUCCESS';

export const ADD_REPORT = 'ADD_REPORT';
export const ADD_REPORT_FAILURE = 'ADD_REPORT_FAILURE';
export const ADD_REPORT_SUCCESS = 'ADD_REPORT_SUCCESS';

export const MAKE_DEFAULT = 'MAKE_DEFAULT';
export const MAKE_DEFAULT_FAILURE = 'MAKE_DEFAULT_FAILURE';
export const MAKE_DEFAULT_SUCCESS = 'MAKE_DEFAULT_SUCCESS';

export const RESET_DEFAULT = 'RESET_DEFAULT';
export const RESET_DEFAULT_FAILURE = 'RESET_DEFAULT_FAILURE';
export const RESET_DEFAULT_SUCCESS = 'RESET_DEFAULT_SUCCESS';

export const ADD_REPORT_TO_HISTORY = 'ADD_REPORT_TO_HISTORY';
export const REMOVE_REPORTS_FROM_HISTORY = 'REMOVE_REPORTS_FROM_HISTORY';

export const SET_SELECTED_ROW_ESSENTIAL_DATA = 'SET_SELECTED_ROW_ESSENTIAL_DATA';
export const CLEAR_SELECTED_ROW_ESSENTIAL_DATA = 'CLEAR_SELECTED_ROW_ESSENTIAL_DATA';

export const CLOSE_ACTIVE_REPORT = 'CLOSE_ACTIVE_REPORT';

export const get_reports = createAction(`${GET_REPORTS}`);
export const get_reports_failure = createAction(`${GET_REPORTS_FAILURE}`);
export const get_reports_success = createAction(`${GET_REPORTS_SUCCESS}`, props<{ reports: Array<IReport> }>());

export const get_stats_success = createAction(
    `${GET_STATS_SUCCESS}`,
    props<{
        title: {
            original: string;
            i18nTitle?: string;
        };
        execute_automatically: boolean;
        show_history_data: boolean;
        stats: Array<Partial<StatKey>>;
        hasActiveLaborMatrix: boolean;
    }>(),
);
export const get_stats_failure = createAction(`${GET_STATS_FAILURE}`);

export const add_dashboard_dates = createAction(
    `[REPORTS_REDUCER] ${ADD_DASHBOARD_DATES}`,
    props<{ dates: Array<any> }>(),
);
export const add_dashboard_dayparts = createAction(
    `[REPORTS_REDUCER] ${ADD_DASHBOARD_DAYPARTS}`,
    props<{ dayparts: Array<any> }>(),
);
export const add_dashboard_destination = createAction(
    `[REPORTS_REDUCER] ${ADD_DASHBOARD_DESTINATIONS}`,
    props<{ destination: Array<any> }>(),
);
export const add_dashboard_hours = createAction(
    `[REPORTS_REDUCER] ${ADD_DASHBOARD_HOURS}`,
    props<{ hours: Array<any> }>(),
);
export const add_dashboard_header = createAction(
    `[REPORTS_REDUCER] ${ADD_DASHBOARD_HEADER}`,
    props<{ header: Array<any> }>(),
);
export const set_dashboard_last_run_filter = createAction(
    `[REPORTS_REDUCER] ${SET_DASHBOARD_LAST_RUN_FILTER}`,
    props<{
        date: IDatepickerValue;
        sites: Array<ISite>;
    }>(),
);

export const select_report = createAction(
    `[REPORTS_REDUCER] ${SELECT_REPORT}`,
    props<{ report: IReport | IPublishedReport; filters?: any; isDrillDown?: boolean }>(),
);
export const remove_report = createAction(`[REPORTS_REDUCER] ${REMOVE_REPORT}`);
export const select_report_success = createAction(
    `[REPORTS_REDUCER] ${SELECT_REPORT_SUCCESS}`,
    props<{ report: IReport | IPublishedReport; filters: Array<any> }>(),
);
export const select_report_failure = createAction(`[REPORTS_REDUCER] ${SELECT_REPORT_FAILURE}`);

export const set_report_filters = createAction(
    `[REPORTS_REDUCER] ${SET_REPORT_FILTER}`,
    props<{ reportFilters: Array<any> }>(),
);
export const set_report_filters_success = createAction(
    `[REPORTS_REDUCER] ${SET_REPORT_FILTER_SUCCESS}`,
    props<{ reportFilters: Array<any> }>(),
);
export const set_report_filters_failure = createAction(`[REPORTS_REDUCER] ${SET_REPORT_FILTER_FAILURE}`);

export const set_report_etl_statistics = createAction(
    `[REPORTS_REDUCER] ${SET_REPORT_ETL_STATISTICS}`,
    props<{ reportName: string }>(),
);
export const set_report_etl_statistics_failure = createAction(`[REPORTS_REDUCER] ${SET_REPORT_ETL_STATISTICS_FAILURE}`);
export const set_report_etl_statistics_success = createAction(
    `[REPORTS_REDUCER] ${SET_REPORT_ETL_STATISTICS_SUCCESS}`,
    props<{ jobStatus; jobStarted; jobFinished; jobDuration }>(),
);
export const reset_report_etl_statistics = createAction(`[REPORTS_REDUCER] ${RESET_REPORT_ETL_STATISTICS}`);
export const set_report_url = createAction(
    `[REPORTS_REDUCER] ${SET_REPORT_URL}`,
    props<{ reportUrl: ReportOptions | string | object }>(),
);
export const set_report_url_failure = createAction(`[REPORTS_REDUCER] ${SET_REPORT_URL_FAILURE}`);
export const set_report_url_success = createAction(
    `[REPORTS_REDUCER] ${SET_REPORT_URL_SUCCESS}`,
    props<{ reportUrl: ReportOptions | string | object }>(),
);

export const add_report = createAction(
    `[REPORTS_REDUCER] ${ADD_REPORT}`,
    props<{ companyId; gridOptions; parentReport; permissions; detailPageOptions }>(),
);
export const add_report_failure = createAction(`[REPORTS_REDUCER] ${ADD_REPORT_FAILURE}`);
export const add_report_success = createAction(`[REPORTS_REDUCER] ${ADD_REPORT_SUCCESS}`);

export const make_default = createAction(
    `[REPORTS_REDUCER] ${MAKE_DEFAULT}`,
    props<{ companyId; gridOptions; report }>(),
);
export const make_default_failure = createAction(`[REPORTS_REDUCER] ${MAKE_DEFAULT_FAILURE}`);
export const make_default_success = createAction(
    `[REPORTS_REDUCER] ${MAKE_DEFAULT_SUCCESS}`,
    props<{ report; gridOptions }>(),
);

export const reset_default = createAction(`[REPORTS_REDUCER] ${RESET_DEFAULT}`, props<{ companyId; report }>());
export const reset_default_failure = createAction(`[REPORTS_REDUCER] ${RESET_DEFAULT_FAILURE}`);
export const reset_default_success = createAction(`[REPORTS_REDUCER] ${RESET_DEFAULT_SUCCESS}`, props<{ report }>());

export const add_report_to_history = createAction(
    `[REPORTS_REDUCER] ${ADD_REPORT_TO_HISTORY}`,
    props<{ reportOptions: IReport | IPublishedReport; filters: { [key: string]: string } }>(),
);
export const remove_reports_from_history = createAction(
    `[REPORTS_REDUCER] ${REMOVE_REPORTS_FROM_HISTORY}`,
    props<{ index: number }>(),
);

export const set_selected_row_essential_data = createAction(
    `[REPORTS_REDUCER] ${SET_SELECTED_ROW_ESSENTIAL_DATA}`,
    props<{
        reportExecutionData: ParentReportExecutionDataModel;
        reportId: string;
    }>(),
);
export const clear_selected_row_essential_data = createAction(`[REPORTS_REDUCER] ${CLEAR_SELECTED_ROW_ESSENTIAL_DATA}`);

export const close_active_report = createAction(`[REPORTS_REDUCER] ${CLOSE_ACTIVE_REPORT}`);
